// extracted by mini-css-extract-plugin
export default {"root":"styles_root__K3sBi","sign":"styles_sign__C8N9R"};